import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { CommonService } from '../../../../shared/services/common.service';
import {
  buildDailyReportSearchNavigation,
  componentsList,
  dailyReportIconOf,
  matchedHintHtmlOf,
} from '../../../../shared/constants/search-entities';

@Component({
    selector: 'app-daily-report-card',
    templateUrl: './daily-report-card.component.html',
    styleUrls: ['./daily-report-card.component.scss'],
    standalone: false
})
export class DailyReportCardComponent implements OnInit, OnDestroy {

  @Input() dailyReport: any;
  // Icon of the first matched component (bid items, labor, forms, ...).
  icon: string;
  componentsList: any;
  matchedHintHtml: string;
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private router: Router,
    private commonService: CommonService,
  ) {
  }

  ngOnInit() {
    // Shared with the header typeahead: names the form WIDGETS that matched
    // rather than the umbrella `control_forms` component.
    this.componentsList = componentsList(this.dailyReport);
    this.icon = dailyReportIconOf(this.dailyReport);
    // Block-labeled matched excerpt (e.g. "Labor & equipment: HTS- Kevin ...")
    // rendered under the "N matches" summary line.
    this.matchedHintHtml = matchedHintHtmlOf(this.dailyReport);
  }

  redirectToDailyReport(dailyReport: any) {
    const nav = buildDailyReportSearchNavigation(dailyReport);

    // Same as the generic result click: remember this results page so the
    // header can offer "Back to search results" on the report page.
    this.commonService.searchResultsUrl = this.router.url;
    this.router.navigate(nav.commands, {
      queryParams: nav.queryParams,
      queryParamsHandling: 'merge',
    });
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
